var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('edicion-facturacion',{attrs:{"datos":_vm.info},on:{"reload-data":function($event){return _vm.loadFactData($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }